<template>
  <v-dialog
    transition="dialog-bottom-transition"
    v-model="show"
    persistent
    scrollable
    max-width="500"
  >
    <v-card class="mx-auto" max-width="500">
      <v-system-bar
        v-if="!this.emptyObject(this.application)"
        :color="primaryColor(generalExApplicationEx)"
        dark
      >
        <v-spacer></v-spacer>
        <v-icon @click="closeApplications"> mdi-close </v-icon>
      </v-system-bar>

      <v-toolbar :color="primaryColor(generalExApplicationEx)" dark>
        <v-btn icon>
          <v-icon>mdi-apps</v-icon>
        </v-btn>

        <v-toolbar-title class="text-button">
          {{ translatedText("applications") }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-text-field
          v-if="search != null"
          v-model="search"
          clearable
          filled
          hide-details
          rounded
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn icon @click="showSearch">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon @click="switchLanguage">
          {{ invertedLanguage(generalExApplicationEx) }}
        </v-btn>
        <v-btn icon @click="logoff">
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container fluid v-if="loading || applicationsEx.length == 0">
        <v-row dense>
          <v-col v-for="id in 3" :key="id" :cols="colsByLine()">
            <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid v-if="!loading">
        <v-row v-for="line in appLines()" :key="line.index" dense>
          <v-col
            v-for="app in appColumns(line.index)"
            :key="app.id"
            :cols="colsByLine()"
          >
            <v-card hover raised rounded>
              <v-img
                :src="app.application.urlImage"
                :lazy-src="app.application.urlImage"
                height="150px"
                gradient="to top right, rgba(50,50,50,.8), rgba(50,50,50,.8)"
                dark
              >
                <v-card-text
                  v-text="
                    translatedConfig(
                      generalExApplicationEx,
                      customLanguage,
                      app.application,
                      'description'
                    )
                  "
                ></v-card-text>
              </v-img>
              <v-card-actions>
                <v-btn
                  depressed
                  block
                  link
                  rounded
                  :color="app.application.buttonColor"
                  :outlined="app.application.outlined"
                  @click="app.action"
                >
                  <v-icon :color="app && app.theme ? app.theme.priColor : null">
                    {{
                      currentApplication(app.index)
                        ? "mdi-square-rounded"
                        : "mdi-square-rounded-outline"
                    }}
                  </v-icon>
                  <div class="text-caption">
                    {{
                      translatedConfig(
                        generalExApplicationEx,
                        customLanguage,
                        app.application,
                        "title"
                      )
                    }}
                  </div>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ApplicationSelection",
  data() {
    return {
      applicationsEx: [],
      show: false,
      loading: false,
      search: null,
      indexSelected: null,
    };
  },
  props: [
    "session",
    "application",
    "generalExApplicationEx",
    "environment",
    "applicationName",
    "customLanguage",
  ],
  methods: {
    getApplications(roles) {
      this.applicationsEx = [];
      this.loading = true;
      this.apiGetApplications({ body: Array.isArray(roles) ? roles : [roles] })
        .then((applicationsExRes) => {
          if (applicationsExRes.data.length > 0) {
            this.loading = false;
            this.applicationsEx = [];
            applicationsExRes.data.forEach((applicationEx) => {
              if (!applicationEx.application.hideSelection) {
                this.applicationsEx.push(applicationEx);
              }
            });
          } else {
            this.goToLogin(this.applicationName);
          }
        })
        .catch((applicationsError) => {
          this.loading = false;
          console.log(applicationsError);
        });
    },

    showApplications() {
      //this.validateSession();
      const sessionGral = this.loadSession();
      if (sessionGral.loggedIn) {
        this.show = true;
        this.getApplications(sessionGral.details.roles);
      }
    },

    appsByLine() {
      return 3;
    },

    colsByLine() {
      return Math.ceil(12 / this.appsByLine());
    },

    allApplications() {
      const search = this.search ? this.search.toLowerCase() : "";
      const result = this.applicationsEx.filter(function (applicationEx) {
        return (
          search == "" ||
          applicationEx.application.name.toLowerCase().includes(search) ||
          applicationEx.application.title.toLowerCase().includes(search)
        );
      });
      return result;
    },

    appLines() {
      let lines = [];
      let count = Math.ceil(this.allApplications().length / this.appsByLine());
      for (let i = 0; i < count; i++) {
        const line = {
          index: i,
        };
        lines.push(line);
      }
      return lines;
    },

    appColumns(lineIndex) {
      let apps = [];
      this.allApplications().forEach((app, index) => {
        const thisLine = Math.trunc(index / this.appsByLine());
        if (thisLine == lineIndex) {
          app.index = index;
          (app.action = () => {
            this.selectApplication(index);
          }),
            (app.current = this.currentApplication(index));
          app.buttonColor = app.current ? "primary" : null;
          app.outlined = app.current;
          apps.push(app);
        }
      });
      return apps;
    },

    currentApplication(applicationIndex) {
      let result = false;
      if (this.allApplications() != []) {
        const currentApp = this.allApplications()[applicationIndex];
        result = currentApp.application.name == this.applicationName;
      }
      return result;
    },

    selectApplication(applicationIndex) {
      this.show = false;
      if (!this.currentApplication(applicationIndex)) {
        const selected = this.allApplications()[applicationIndex].application;
        this.$emit("select-application", selected);
      }
    },

    closeApplications() {
      this.show = false;
    },

    logoff() {
      this.closeApplications();
      this.$emit("logoff");
    },

    showSearch() {
      this.search = this.search == null ? "" : this.search;
    },

    switchLanguage() {
      this.$emit("switch-language");
    },
  },
  created() {
    if (this.emptyObject(this.application)) {
      this.showApplications();
    }
  },
};
</script>

<style>
</style>